// Create Redux action types
export const GET_USERS = 'GET USERS'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS'


// Create Redux action creators that return an action
export const getUsers = () => ({
    type: GET_USERS,
})

export const getUsersSuccess = users => ({
    type: GET_USERS_SUCCESS,
    payload: users,
})

export const getUsersFailure = () => ({
    type: GET_USERS_FAILURE,
})

export const userLoginSuccess = () => ({
    type: USER_LOGIN_SUCCESS,
})

export const userLogoutSuccess = () => ({
    type: USER_LOGOUT_SUCCESS,
})

// Combine them all in an asynchronous thunk
export function fetchUsers() {
    return async dispatch => {
        dispatch(getUsers())
        try {
            dispatch(getUsersSuccess(true))
        } catch (error) {
            dispatch(getUsersFailure())
        }
    }
}

// Login fn
export function loginSuccess(){
    return async dispatch => {
        await dispatch(userLoginSuccess())
    }
}

// Logout fn
export function logoutSuccess(){
    localStorage.clear();
    return async dispatch => {
        dispatch(userLogoutSuccess())
    }
}